import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "vab-icon-up_line",
  "use": "vab-icon-up_line-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"vab-icon-up_line\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.293 8.29289C11.6835 7.90237 12.3167 7.90237 12.7072 8.29289L18.3641 13.9498C18.7546 14.3403 18.7546 14.9734 18.3641 15.364C17.9735 15.7545 17.3404 15.7545 16.9498 15.364L12.0001 10.4142L7.05037 15.364C6.65985 15.7545 6.02668 15.7545 5.63616 15.364C5.24563 14.9734 5.24563 14.3403 5.63616 13.9498L11.293 8.29289Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol